export function orderPages(pages, order) {
  const indexes = pages.reduce((a, v) => {
    a[v.id] = v
    return a
  }, {})
  return order.map(x => indexes[x])
}
